<template>
  <div>
    <v-toolbar flat dense color="white">
     <v-chip color="green" style="height: 22px" class="white--text" v-if="applicationInfo.isResolved && applicationInfo.isApproved">Approved</v-chip>
        <v-chip color="red" style="height: 22px" class="white--text" v-else-if="applicationInfo.isResolved && applicationInfo.isDenied">Denied</v-chip>
        <v-chip color="light-blue" style="height: 22px" class="white--text" v-else>Pending</v-chip>
        <v-toolbar-title>Order ID: {{ applicationInfo.id }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="applicationInfo.isDeviceVerified">
        <v-btn
          round
          color="primary"
          class="white--text"
          v-if="
            !applicationInfo.isResolved &&
              !applicationInfo.ispVerified &&
              applicationInfo.packagesIsp.datatillProductId &&
              datatillIntegration
          "
          @click="
            clearIntegrationFields();
            addCustomerModal = true;
          "
          >Approve</v-btn
        >
        <v-btn
          round
          color="primary"
          class="white--text"
          v-else-if="!applicationInfo.isResolved && !applicationInfo.ispVerified"
          @click="
            clearIntegrationFields();
            ispVerifyModal();
          "
          >Approve</v-btn
        >
      
        <small class="grey--text " v-else-if="applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null">
          Approved By: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
          <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
        </small>
        <small class="grey--text " v-else-if="!applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null">
          Rejected By: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
          <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
        </small>
        <v-btn
          round
          color="red"
          class="white--text"
          v-if="!applicationInfo.isResolved && !applicationInfo.ispVerified"
          @click="deniedReasonModal = true"
          >Reject</v-btn
        >
      </div>
      <span v-else class="grey--text "
        >Device verification is required by the FNO before you are able to approve this application.</span
      >
    </v-toolbar>
    <v-divider></v-divider>
    <v-stepper v-model="stepperModel" class="elevation-0" alt-labels>
        <v-stepper-header>
            <v-stepper-step step="1" complete color="light-green">
                Order Received
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="light-green" :disabled="true" style="cursor: pointer; text-align: center" step="2" :complete="applicationInfo.isContactVerified">
                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center">Contact(s) Verified</v-flex>

                </v-layout>

            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step color="light-green" style="cursor: pointer" :complete="applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified" step="3">
                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center">Install Verified</v-flex>
                </v-layout>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :rules="[() =>{
              if(applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified&&applicationInfo.ispVerifiedById != null){
                return true
              } else if(applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified&&applicationInfo.ispVerifiedById == null){
                return false
              } else {
                return true
              }
              
              }]" color="light-green" :complete="applicationInfo.ispVerifiedById">

                <v-layout justify-center wrap>
                    <v-flex xs12 class="text-xs-center" v-if="applicationInfo.ispVerifiedById && applicationInfo.ispAccepted">ISP Approved</v-flex>
                    <v-flex xs12 class="text-xs-center" v-else-if="applicationInfo.ispVerifiedById && !applicationInfo.ispAccepted">ISP Rejected</v-flex>
                    <v-flex xs12 class="text-xs-center" v-else>ISP Approved</v-flex>


                </v-layout>

            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" color="light-green" :complete="applicationInfo.isResolved && applicationInfo.isApproved" :rules="[
            () => {
              if(applicationInfo.ispVerifiedById){
                 if(applicationInfo.ispAccepted&&applicationInfo.isResolved){
                if (applicationInfo.isResolved && applicationInfo.isDenied) {
                return false;
              } else {
                return true;
              }
              } else {
                return false
              }
              } else {
                return true
              }
             
              
            },
          ]">
                FNO Approved
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="6" color="light-green" :complete="applicationInfo.isResolved" style="cursor: pointer">
                <span @click="
              applicationInfo.serviceAccountId ? redirectToServiceAccount(applicationInfo.serviceAccountId) : null
            ">{{ applicationInfo.serviceAccount ? applicationInfo.serviceAccount.circuitNumber : "Complete" }}</span>
            </v-stepper-step>
        </v-stepper-header>
    </v-stepper>

    <v-card flat>

        <v-card-text style="margin: 0; padding: 0">
            <v-layout wrap>
                <v-flex xs12 sm8>
                    <v-layout justify-start wrap>
                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0"> Order Summary</v-subheader>
                                 <span v-if="applicationInfo.deniedReason" style="padding: 5px; margin: 5px;"><b style="left: 5">Reason for Denial:</b>
                                    <p style="padding: 5px; margin: 5px; color: red">{{ applicationInfo.deniedReason }}</p>
                                </span>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Date Submitted
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ formatDate(applicationInfo.createdAt) }}
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>event</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Preferred Activation Date:
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.activationDate }}
                                    </v-list-tile-action>
                                </v-list-tile>
                                 <v-list-tile three-line v-if="applicationInfo.packagesIspId !== null && applicationInfo.packagesIsp">
                                    <v-list-tile-action>
                                        <v-icon>bolt</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.packagesIsp.name }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ applicationInfo.ispOnceOffPriceVatInc | currency }} Once Off
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.ispRecurringPriceVatInc | currency }}pm
                                    </v-list-tile-action>
                                </v-list-tile>

                                <span v-if="applicationInfo.notes" style="padding: 5px; margin: 5px;"><b style="left: 5">Notes:</b>
                                    <p style="padding: 5px; margin: 5px">{{ applicationInfo.notes }}</p>
                                </span>
                                
                                <v-subheader v-if="applicationInfo.supplierOrganisation" style="background: #f0f0f0">Network Operator</v-subheader>
                                <v-list-tile three-line v-if="applicationInfo.supplierOrganisation">
                                    <v-list-tile-avatar>
                                        <v-img :src="applicationInfo.supplierOrganisation.logo" contain></v-img>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.supplierOrganisation.name }}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>paid</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Installation Fee
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.routerInstallationFee | currency }}<br>
                                        <small>incl. VAT</small>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="applicationInfo.packagesIsp.packagesFno.setupFee>0 || (applicationInfo.location&&applicationInfo.location.locationNetwork.activationFeeAmount>0)">
                                    <v-list-tile-action>
                                        <v-icon>paid</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Setup/Activation Fee
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <!-- <v-list-tile-action v-if="((applicationInfo.packagesIsp.packagesFno.setupFee != null) && (applicationInfo.packagesIsp.packagesFno.setupFee != 0))"> -->
                                    <v-list-tile-action v-if="applicationInfo.packagesIsp.packagesFno.setupFee">
                                      {{ applicationInfo.packagesIsp.packagesFno.setupFee | currency }}
                                        <br/>
                                        <small>excl. VAT</small>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else-if="(applicationInfo.location) && (applicationInfo.location.locationNetwork.activationFeeAmount > 0)">
                                        {{ applicationInfo.location.locationNetwork.activationFeeAmount | currency }}
                                        <br/>
                                        <small>excl. VAT</small>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else>
                                        {{ applicationInfo.packagesIsp.packagesFno.setupFee | currency }}
                                        <br/>
                                        <small>excl. VAT</small>
                                    </v-list-tile-action>
                                    <!-- <v-list-tile-action style="fontSize: 14px" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.activationFeeAmount>0">
                                        {{ applicationInfo.location.locationNetwork.activationFeeAmount | currency }}
                                        <br/>
                                        <small>excl. VAT</small>
                                    </v-list-tile-action>
                                    <v-list-tile-action v-else style="fontSize: 14px">
                                      {{ applicationInfo.packagesIsp.packagesFno.setupFee | currency }}<br>
                                      <small>excl. VAT</small>
                                    </v-list-tile-action> -->
                                </v-list-tile>
                                 <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>paid</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                           {{applicationInfo.packagesIsp.packagesFno.packageCode}}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            Package Fee
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        {{ applicationInfo.packagesIsp.packagesFno.packageBasePrice | currency }} pm <br>
                                        <small>excl. VAT</small>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.isValidPromo !== null">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            Promotion Code:
                                        </v-list-tile-title>
                                        <v-list-tile-subtitle>
                                            <span v-if="applicationInfo && applicationInfo.promotion" class="grey--text font-weight-light">
                                                {{ applicationInfo.promotion.name }}
                                            </span>
                                            <span v-else-if="applicationInfo && applicationInfo.promoCode" class="grey--text font-weight-light">
                                                {{ applicationInfo.promoCode }}
                                            </span>
                                        </v-list-tile-subtitle>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="fontSize: 14px">
                                        <v-chip small v-if="applicationInfo.isValidPromo == true" class="white--text" color="light-green">Valid</v-chip>
                                        <v-chip small v-else class="white--text" color="orange">Invalid</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>
                                
                            </v-list>
                        </v-flex>
                         <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; ">
                            <!-- <h3>
                        <v-icon v-if="!applicationInfo.isResolved && !applicationInfo.isContactVerified" color="orange">warning</v-icon>Contact Information
                    </h3> -->
                            <v-subheader style="background: #f0f0f0"> Contact Information</v-subheader>
                            <v-list three-line v-if="showLocationContacts==0">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">1st</v-avatar>
                                            </template>
                                            <span>Primary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.primaryContactTitle }}
                                            {{ applicationInfo.primaryContactFirstname }}
                                            {{ applicationInfo.primaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.primaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.primaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">person</v-icon> {{ applicationInfo.primaryContactIdNumber }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.secondaryContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue" class="white--text">2nd</v-avatar>
                                            </template>
                                            <span>Secondary Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.secondaryContactTitle }}
                                            {{ applicationInfo.secondaryContactFirstname }}
                                            {{ applicationInfo.secondaryContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.secondaryContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.secondaryContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                         <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">person</v-icon> {{ applicationInfo.secondaryContactIdNumber }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile v-if="applicationInfo.billingContactFirstname !== null">
                                    <v-list-tile-action>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-avatar size="32px" v-on="on" color="blue">
                                                    <v-icon color="white">attach_money</v-icon>
                                                </v-avatar>
                                            </template>
                                            <span>Billing Contact</span>
                                        </v-tooltip>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ applicationInfo.billingContactTitle }}
                                            {{ applicationInfo.billingContactFirstname }}
                                            {{ applicationInfo.billingContactLastname }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">smartphone</v-icon> {{ applicationInfo.billingContactMobileNumber }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.billingContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="fontSize: 12px">
                                            <v-icon small color="grey">email</v-icon> {{ applicationInfo.billingContactEmailAddress }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>

                        <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; ">

                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0">Location Information</v-subheader>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon v-if="applicationInfo.location">location_on</v-icon>
                                        <v-icon color="warning" v-else>warning</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px" v-if="applicationInfo.location">
                                            {{ applicationInfo.location.locationDescription }}
                                        </v-list-tile-title>
                                        <v-list-tile-title style="fontSize: 14px" v-else>
                                            {{ formattedAddress }}
                                        </v-list-tile-title>
                                        <v-list-tile-subtitle style="fontSize: 14px">
                                            <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
                                            <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
                                            <v-chip style="height: 18px" class="white--text" color="green" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Live'">Live</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="blue" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='In Progress'">In Progress</v-chip>
                                            <v-chip style="height: 18px" class="white--text" color="orange" v-if="applicationInfo.location&&applicationInfo.location.locationNetwork.networkStatus=='Planned'">Planned</v-chip>
                                        </v-list-tile-subtitle>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-subheader style="background: #f0f0f0">Installed Equipment</v-subheader>
                                <v-layout align-center>
                                    <v-flex xs6>
                                        <v-list-tile v-if="applicationInfo.location">
                                            <v-list-tile-action>
                                                <v-icon>cable</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title style="fontSize: 14px">
                                                    Fibre:
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="green" v-if="applicationInfo.location.fibrePulled">check_circle_outline</v-icon>
                                                <v-icon color="red" v-else>not_interested</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-list-tile v-if="applicationInfo.location">
                                            <v-list-tile-action>
                                                <v-icon>router</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-content>
                                                <v-list-tile-title style="fontSize: 14px">
                                                    Device:
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon color="green" v-if="applicationInfo.location.equipmentInstalled && device">check_circle_outline</v-icon>
                                                <v-icon color="red" v-else>not_interested</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-flex>
                                </v-layout>
                                <v-list-tile v-if="device">
                                    <v-list-tile-action>
                                        <v-icon>router</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ device.ponMac }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ device.deviceMakeModel.deviceMake.name }}
                                            {{ device.deviceMakeModel.name }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-subheader v-if="existingServiceAccounts.length>0" style="background: #f0f0f0">Current Service Accounts</v-subheader>

                                <v-list-tile v-for="serviceAccount in existingServiceAccounts" :key="serviceAccount.id" @click="routeToServiceAccount(serviceAccount.id)">
                                    <v-list-tile-action>
                                        <v-icon>miscellaneous_services</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="fontSize: 14px">
                                            {{ serviceAccount.circuitNumber }}
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="fontSize: 14px">
                                            {{ serviceAccount.customerOrganisation.name }}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-chip style="height: 18px" outline v-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&serviceAccount.isSuspended&&serviceAccount.isActive" class="white--text" color="orange">Suspended</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate!==null&&new Date(serviceAccount.fnoActivationDate)<new Date()&&(new Date(serviceAccount.fnoDeactivationDate)>new Date()||serviceAccount.fnoDeactivationDate==null)" class="white--text" color="light-green">Active</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate!==null&&serviceAccount.fnoDeactivationDate!=null&&(new Date(serviceAccount.fnoDeactivationDate)<new Date())" class="white--text" color="red">Inactive</v-chip>
                                        <v-chip style="height: 18px" outline v-else-if="serviceAccount.fnoActivationDate==null||new Date(serviceAccount.fnoActivationDate)>new Date()" class="white--text" color="blue">Pending</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>

                            </v-list>
                        </v-flex>
                         <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey; " :key="ticketKey">
                            <v-list subheader>
                                <v-subheader style="background: #f0f0f0">Documents</v-subheader>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>description</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style=" align-text: center;cursor: pointer" v-if="documents.length>0" @click="documentsModal=true">
                                            <v-chip style="height: 20px">{{documents.length}}</v-chip> Document(s)
                                        </v-list-tile-title>
                                        <v-list-tile-title v-else>
                                            No documents
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>

                                        <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                            <div class="dropZone-info" @drag="onChange">
                                                <span class="dropZone-title">Drop file or click to upload</span>
                                            </div>
                                            <input type="file" @change="onChange">
                                        </div>

                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-subheader :key="ticketKey" style="background: #f0f0f0">Tickets <v-chip>{{ tickets.length }}</v-chip>
                                    <v-spacer></v-spacer>
                                    <!-- <v-icon color="primary" @click="createTicket('')">add_circle_outline</v-icon> -->
                                    <v-icon color="primary" @click="fetchTickets()">refresh</v-icon>
                                </v-subheader>
                                <v-data-table :rows-per-page-items="5" :key="ticketKey" :items="tickets" hide-headers style="cursor: pointer">
                                    <template v-slot:items="props">
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ props.item.id }}
                                        </td>

                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            <h3 class="grey--text">
                                                <v-chip small :class="`${props.item.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`">{{ props.item.currentStatus }}</v-chip>
                                            </h3>
                                        </td>
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ props.item.ticketCategoryItem.name }}
                                        </td>
                                        <td class="text-xs-center" @click="routeToTicketSummary(props.item.id)">
                                            {{ formatDate(props.item.dueDate) }}
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-flex>
                  <v-flex xs12 sm4>
                    <v-subheader style="background: #f0f0f0">Comments</v-subheader>
                    <v-layout align-center justify-center class="ma-2">
                        <v-flex xs10>

                            <at-ta :members="members">
                                <v-textarea  auto-grow rows="1" outline row-height="10" v-model="comment"></v-textarea>
                                <!-- <wysiwyg v-model="comment.comment" /> -->
                            </at-ta>
                        </v-flex>
                        <v-flex xs2 class="text-xs-center" style="text-align: center">
                            <v-btn icon @click="addApplicationComment(comment)">
                                <v-icon>send</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <div style="overflow-y: auto; max-height: 50vh;">
                        <v-layout v-for="item in commentArray" :key="item.id" justify-start align-center style="border-bottom: 1px solid lightgrey">
                            <v-flex xs3 class="text-xs-left ml-1">
                                <b>{{ item.commentedByName
                            }} {{ item.commentedBySurname}}</b> <br>
                                <small>{{item.organisation.name}}</small> <br />
                                <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                            </v-flex>
                            <v-flex class="text-xs-left pa-2" xs8>

                                <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
      </v-card>
   

    <v-dialog v-model="deniedReasonModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">Please provide a reason for denying the application</h3>
        </v-toolbar>
        <v-card-text>
          <v-textarea label="Reason for Rejection" v-model="deniedReason"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" class="white--text" @click="deniedReasonModal = false">Cancel</v-btn>
            <v-btn v-if="deniedReason" round color="primary" class="white--text" @click="rejectApplication"
              >Reject Application</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

  

    <!-- Service Account details Modal -->
    <v-dialog v-model="serviceAccountDetailsModal" persistent max-width="750px" min-width="300px">
      <v-card flat>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Service Account Details</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="serviceAccountDetailsModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout ma-1 justify-center>
            <v-flex xs4>
              <v-select
                :items="connectionTypes"
                v-model="applicationInfo.serviceAccountType"
                label="Type of connection"
              ></v-select>
            </v-flex>
            <v-flex xs8 v-if="applicationInfo.serviceAccountType == 'PPPoE'">
              <v-layout>
                <v-text-field label="PPPoE Username" v-model="applicationInfo.pppoeUsername"></v-text-field>
                <v-text-field label="PPPoE Password" v-model="applicationInfo.pppoePassword"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              class="white--text"
              color="primary"
              v-if="applicationInfo.serviceAccountType == 'IPoE'"
              @click="submitApproval()"
              >Submit</v-btn
            >
            <v-btn
              round
              class="white--text"
              color="primary"
              v-else-if="
                applicationInfo.serviceAccountType == 'PPPoE' &&
                  applicationInfo.pppoeUsername &&
                  applicationInfo.pppoePassword
              "
              @click="submitApproval()"
              >Submit</v-btn
            >
            <v-btn round disabled v-else>Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="configModal" width="750px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">SERVICE CONFIGURATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="(configModal = false), (configurationSettings = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="configurationSettings.type == 'Multiple'">
            <v-layout justify-center align-center wrap>
              <v-flex xs10 mx-1 my-1 v-if="configurationSettings.bridgeTemplates.length > 1">
                <h4 class="grey--text">
                  There are multiple configurations available for this device. Please choose the preferred
                  configuration:
                </h4>
              </v-flex>
              <v-flex xs8 mx-1 mt-2 v-for="template in configurationSettings.bridgeTemplates" :key="template.id">
                <v-card
                  color="white"
                  :hover="configurationSettings.selectedTemplateId !== template.id"
                  @click="
                    (configurationSettings.selectedTemplateId = template.id),
                      (configurationSettings.connectionType = template.connectionType)
                  "
                >
                  <v-toolbar
                    flat
                    :color="configurationSettings.selectedTemplateId == template.id ? 'light-green' : 'primary'"
                  >
                    <h3 class="title white--text" v-if="template.type == 'OneDevice'">One Device</h3>
                    <h3 class="title white--text" v-else>Two Device</h3>
                    <v-spacer></v-spacer>
                    <v-icon large v-if="configurationSettings.selectedTemplateId == template.id" color="white"
                      >check_circle</v-icon
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-layout justify-left align-center mx-1 wrap class="text-xs-left">
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text">Connection Type:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text font-weight-light">{{ template.connectionType }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text">Inner VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text font-weight-light">{{ template.innerVlan }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text">Outer VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text font-weight-light">{{ template.outerVlan }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text">Terms:</h3>
                      </v-flex>
                      <v-flex xs6 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text font-weight-light">
                          Second device is NOT provided by the network operator and will need to either be supplied by
                          the ISP or the end customer.
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div
            v-if="configurationSettings.connectionType && configurationSettings.connectionType.toLowerCase() == 'pppoe'"
          >
            <v-layout align-center justify-center wrap my-1>
              <v-flex xs10 mx-1 mt-2>
                <h3 class="title grey--text">PPPoE Configuration</h3>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field label="PPPoE Username" v-model="configurationSettings.pppoeUsername"></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field label="PPPoE Password" v-model="configurationSettings.pppoePassword"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center align-center>
            <v-btn
              round
              color="primary"
              class="white--text"
              v-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() != 'pppoe'
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() == 'pppoe' &&
                  configurationSettings.pppoeUsername &&
                  configurationSettings.pppoePassword
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn round color="primary" class="white--text" v-else disabled>Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="documentsModal" persistent width="750px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Documents
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="documentsModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs12 v-for="document in documents" :key="document.id">
                        <v-card flat color="white" style="border-top: 1px solid lightgrey">
                            <v-layout justify-left align-center wrap>
                                <v-flex xs3>
                                    <h4 class="grey--text font-weight-light">{{formatDate(new Date(document.createdAt))}}</h4>
                                </v-flex>
                                <v-flex xs7>
                                    <h4 class="grey--text">{{document.name}}</h4>
                                </v-flex>
                                <v-flex xs2>
                                    <v-layout justify-center>
                                        <!-- <v-icon @click="viewFile(document)">open_in_new</v-icon> -->
                                        <v-icon @click="downloadFile(document)">download</v-icon>
                                        <v-icon v-if="document.organisationId == applicationInfo.customerOrganisationId" color="red" @click="deleteFile(document)">delete</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },
  data() {
    return {
      commentArray: [],
      documents: [],
      documentsModal: false,
      ticketCarousalArray: [],
      ticketIndex: 0,
      keepColorId: null,
      selectedExistingCustomer: null,
      datatillContactTypeList: [],
      allCustomers: [],
      selected: [],
      search2: "",
      customerSearchHeaders: [
        {
          text: "Action",
          align: "center",
          value: "action",
        },
        {
          text: "Code",
          align: "center",
          value: "accounting_code",
        },
        {
          text: "Name",
          align: "center",
          value: "contact_name",
        },
        {
          text: "Email Address",
          align: "center",
          value: "contact_email",
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "contact_mobile",
        },
      ],
      addCustomerModal: false,
      foundExisting: [],
      newCustomer: {},
      datatillIntegration: false,
      datatillContactType: "",
      existingDatatillCustomer: false,
      createNewDatatillCustomer: true,
      applicationContactIndex: 0,
      snackbar: false,
      text: "",
      bridgeTemplates: [],
      connectionTypes: ["PPPoE", "IPoE"],
      configModal: false,
      configurationSettings: {},
      editedContact: {},
      editContactModal: false,
      invoiceNumberDialog: false,
      loadingApplication: false,
      addDeviceModal: [],
      xeroContacts: [],
      similarXeroContacts: [],
      addDeviceModal: false,
      installation: {},
      addInstallationModal: false,
      deniedReasonModal: false,
      applicationInfo: "",
      search: "",
      page: 1,
      allDevices: [],
      device: null,
      existingServiceAccounts: [],
      locationContacts: [],
      showApplicationContacts: true,
      showLocationContacts: false,
      linkedPrimaryContacts: [],
      linkedSecondaryContacts: [],
      deniedReason: "",
      linkedBillingContacts: [],
      similarContactsModalPrimary: false,
      similarContactsModalSecondary: false,
      similarContactsModalBilling: false,
      xeroContactsModal: false,
      billedXeroContactId: null,
      provisionTemplate: null,
      verifyingContact: false,
      verifyingInstallation: false,
      verifyingDevice: false,
      creatingPrimaryContact: false,
      creatingSecondaryContact: false,
      creatingBillingContact: false,
      allVlans: [],
      tickets: [],
      ticketItem: {},
      viewTicketModal: false,
      ticketCommentLog: [],
      ticketAssignedLog: [],
      deviceBridges: [],
      provisionWarningModal: false,
      ethPorts: [1, 2, 3, 4],
      changedPort: null,
      ticketKey: 0,
      dateTimeSelect: false,
      serviceAccountDetailsModal: false,
      y: "top",
      devicesLength: 0,
      pagination: { totalItems: 0 },
      tabs: [
        { name: "applicationContacts", displayName: "Application Contacts" },
        { name: "locationContacts", displayName: "Location Contacts" },
      ],
      locationTypeList: ["End Location", "Location Network", "Location Node", "Switching Centre"],
      locationType: "End Location",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      ticketCategories: [],
      comment: "",
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName",
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name",
        },
        {
          text: "Switching Centre",
          align: "center",
          value: "switchingCentre.name",
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name",
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name",
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress",
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress",
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical",
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber",
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name",
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress",
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId",
        },
        {
          text: "Frame",
          align: "center",
          value: "frame",
        },
        {
          text: "Slot",
          align: "center",
          value: "slot",
        },
        {
          text: "Port",
          align: "center",
          value: "port",
        },
        {
          text: "Note",
          align: "center",
          value: "note",
        },
        {
          text: "Active",
          align: "center",
          value: "isActive",
        },
      ],
    };
  },
  async created() {
    this.initialize();
  },
  computed: {
formattedAddress(){
      let address = ''
      if(this.applicationInfo.unitNo){
        address += 'Unit '+this.applicationInfo.unitNo +', '
      }
      if(this.applicationInfo.floorNo){
        address += 'Floor '+this.applicationInfo.floorNo +', '
      }
      if(this.applicationInfo.building){
        address += this.applicationInfo.building +', '
      }
      if(this.applicationInfo.streetNumber){
        address += this.applicationInfo.streetNumber +' '
      }
      if(this.applicationInfo.streetName){
        address += this.applicationInfo.streetName +', '
      }
      if(this.applicationInfo.suburb){
        address += this.applicationInfo.suburb +', '
      }
      if(this.applicationInfo.town){
        address +=this.applicationInfo.town +', '
      }
      if(this.applicationInfo.province){
        address += this.applicationInfo.province +', '
      }
      if(this.applicationInfo.country){
        address += this.applicationInfo.country
      }
      if(this.applicationInfo.postalCode){
        address +=  ' ' + this.applicationInfo.postalCode
      }
      return address
    }
  },
  watch: {
    "$vuetify.breakpoint.lgAndDown": {
      immediate: true,
      async handler(value) {
        console.log(value);
        if (value && value !== null) {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
        } else {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 2);
        }
      },
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        // this.devices= await this.search(value.search)
        this.isLoading = true;
        if (this.$route.query.search && value !== "" && value != null) {
          // debugger
          Api()
            .get("/devices/active", {
              params: {
                search: value,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.offset && this.$route.query.records) {
          // debugger
          Api()
            .get("/devices/active", {
              params: {
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
          // this.fetchDevices()
          // // debugger
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/devices/active", {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.devices = response.data;
              this.devicesLength = this.devices.length;
              this.isLoading = false;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get("/devices/active", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
            },
          });
        }
      }
    },
    datatillContactType(value) {
      if (value === "Primary") {
        this.newCustomer.fullName =
          this.applicationInfo.primaryContactFirstname + " " + this.applicationInfo.primaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.primaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.primaryContactEmailAddress;
      } else if (value === "Secondary") {
        this.newCustomer.fullName =
          this.applicationInfo.secondaryContactFirstname + " " + this.applicationInfo.secondaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.secondaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
      } else if (value === "Billing") {
        this.newCustomer.fullName =
          this.applicationInfo.billingContactFirstname + " " + this.applicationInfo.billingContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.billingContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.billingContactEmailAddress;
      }
      console.log(this.newCustomer);
    },
    selected(value) {
      this.applicationInfo.datatillCustomerId = value.id;

      console.log(value);
    },
  },
  methods: {
    downloadFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            const downloadLink = document.createElement("a");
            const fileName = item.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        deleteFile(item) {
            Api().put('/upload/' + item.id, {
                isActive: false,
                isDeleted: true
            }).then(res => {
                this.documents.splice(this.documents.indexOf(item), 1)
            })
        },
    clearIntegrationFields() {
      this.selected = [];
      this.datatillContactType = "Primary";
      (this.selectedExistingCustomer = null), (this.createNewDatatillCustomer = true);
    },
    clearPackageSelection() {
      let elements = document.getElementsByName("packageCard");
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.border = "none";
        elements[i].style.backgroundColor = "white";
      }
    },
    selectExistingCustomer(pack) {
      this.clearPackageSelection();
      if (this.selectedExistingCustomer === null) {
        this.selectedExistingCustomer = pack;
        this.keepColorId = pack.customerId;

        document.getElementById(pack.customerId).style.backgroundColor = "#e6e6e6";
        document.getElementById(pack.customerId).style.border = "1px solid #99cc33";
      } else {
        if (pack.customerId != this.selectedExistingCustomer.customerId) {
          this.selectedExistingCustomer = pack;
          this.keepColorId = pack.customerId;

          document.getElementById(pack.customerId).style.backgroundColor = "#e6e6e6";
          document.getElementById(pack.customerId).style.border = "1px solid #99cc33";
        } else if (pack.customerId == this.selectedExistingCustomer.customerId) {
          this.selectedExistingCustomer = null;
          this.keepColorId = null;
        }
      }
      console.log(this.selectedExistingCustomer);
    },
    submitApproval() {
      confirm("Are you sure you would like to confirm receipt of this application?") &&
        Api()
          .put("/customer/applications/" + this.$route.params.applicationId, {
            ispVerified: true,
            ispVerifiedById: this.$store.state.user.id,
            ispVerifiedDate: new Date(),
            ispAccepted: true,
            serviceAccountType: this.applicationInfo.serviceAccountType,
            pppoeUsername: this.applicationInfo.pppoeUsername,
            pppoePassword: this.applicationInfo.pppoePassword,
          })
          .then((response) => {
            this.serviceAccountDetailsModal = false;
            (this.applicationInfo.ispVerified = true),
              (this.applicationInfo.ispAccepted = true),
              (this.applicationInfo.ispVerifiedDate = new Date()),
              (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
              (this.applicationInfo.ispVerifiedBy = this.$store.state.user);
          });
    },
    ispVerifyModal() {
      if (this.bridgeTemplates.length == 0) {
        if (this.applicationInfo.organisationId == 336) {
          this.submitConfiguration();
        } else {
          confirm(
            "You do not have any configuration templates for this make. Please set this up with the relevant Fibre Network Operator."
          );
        }
      } else {
        if (this.device) {
          let selectedTemplates = [];
          if (this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice" || x.type == "TwoDevice");
          } else if (this.device.deviceMakeModel.oneDevicePolicy && !this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice");
          } else if (!this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "TwoDevice");
          }
          if (selectedTemplates.length == 0) {
            confirm(
              "You do not have any configuration templates that match the available policies for this device model. Please contact the Fibre Network Operator to rectify this issue."
            );
          } else {
            if (selectedTemplates.length > 0) {
              this.configurationSettings = {
                type: "Multiple",
                bridgeTemplates: selectedTemplates,
                selectedTemplateId: selectedTemplates[0].id,
                connectionType: selectedTemplates[0].connectionType,
              };
              if (selectedTemplates.length > 1 || this.configurationSettings.connectionType.toLowerCase() == "pppoe") {
                this.configModal = true;
              } else {
                this.submitConfiguration();
              }
            }
          }
        }
      }
    },
    submitConfiguration() {
      confirm("Are you sure you would like to confirm receipt of this application?") &&
        Api()
          .put("/customer/applications/" + this.$route.params.applicationId, {
            ispVerified: true,
            ispVerifiedById: this.$store.state.user.id,
            ispVerifiedDate: new Date(),
            ispAccepted: true,
            organisationBridgeTemplateId: this.configurationSettings.selectedTemplateId,
            serviceAccountType: this.configurationSettings.connectionType,
            pppoeUsername: this.configurationSettings.pppoeUsername,
            pppoePassword: this.configurationSettings.pppoePassword,
          })
          .then((response) => {
            if (this.datatillIntegration) {
              if (this.existingDatatillCustomer === true) {
                Api().put("/customer/applications/" + this.$route.params.applicationId, {
                  datatillCustomerId: this.selectedExistingCustomer.customerId,
                });
              } else {
                if (this.createNewDatatillCustomer) {
                  Api()
                    .post("/datatill/addCustomer", {
                      organisationId: this.$store.state.currentOrg.org.id,
                      idNumber: this.newCustomer.idNumber,
                      name: this.newCustomer.fullName,
                      telephoneNumber: this.newCustomer.telephoneNumber,
                      mobileNumber: this.newCustomer.mobileNumber,
                      emailAddress: this.newCustomer.emailAddress,
                      physicalAddress: this.applicationInfo.location.locationDescription,
                      postalAddress: this.applicationInfo.location.locationDescription,
                    })
                    .then((response) => {
                      Api().put("/customer/applications/" + this.$route.params.applicationId, {
                        datatillCustomerId: response.data.customerId,
                      });
                    });
                } else {
                  Api().put("/customer/applications/" + this.$route.params.applicationId, {
                    datatillCustomerId: this.applicationInfo.datatillCustomerId,
                  });
                }
              }
            }

            this.notifyFno();
            this.configModal = false;
            (this.applicationInfo.ispVerified = true),
              (this.applicationInfo.ispAccepted = true),
              (this.applicationInfo.ispVerifiedDate = new Date()),
              (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
              (this.applicationInfo.ispVerifiedBy = this.$store.state.user);
          });
    },
    selectDevice(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.applicationInfo.passiveInstallComplete) {
          confirm("Are you sure you would like to add this device to the location?") &&
            Api()
              .get("/devices/" + item.id)
              .then((response) => {
                this.device = response.data;
                Api()
                  .put("/locations/" + this.applicationInfo.locationId, {
                    equipmentInstalled: true,
                  })
                  .then((response) => {
                    this.applicationInfo.location.equipmentInstalled = true;
                  });
                Api().put("/devices/" + item.id, {
                  locationId: this.applicationInfo.locationId,
                });
                if (this.applicationInfo.serviceAccountId !== null) {
                  Api().put("/serviceAccounts/" + this.applicationInfo.serviceAccountId, {
                    deviceId: item.id,
                  });
                }
              });
        } else {
          confirm("There is currently no passive installation for this location. Would you like to add one now?") &&
            this.generatePassiveInstall();
          confirm("Are you sure you would like to add this device to the location?") &&
            Api()
              .get("/devices/" + item.id)
              .then((response) => {
                this.device = response.data;
                Api()
                  .put("/locations/" + this.applicationInfo.locationId, {
                    equipmentInstalled: true,
                  })
                  .then((response) => {
                    this.applicationInfo.location.equipmentInstalled = true;
                  });
                Api().put("/devices/" + item.id, {
                  locationId: this.applicationInfo.locationId,
                });
                if (this.applicationInfo.serviceAccountId !== null) {
                  Api().put("/serviceAccounts/" + this.applicationInfo.serviceAccountId, {
                    deviceId: item.id,
                  });
                }
                this.addDeviceModal = false;
              });
        }
      }
    },
    async deviceCount() {
      Api()
        .get("/devices/active/count")
        .then((response) => {
          this.devicesLength = response.data.count;
          this.pagination.totalItems = this.devicesLength;
        });
    },
    removeContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/LocationContact/" + item.id, {
            isDeleted: true,
            isActive: false,
          })
          .then((response) => {
            (item.isActive = false), (item.isDeleted = true);
          });
        let index = this.locationContacts.indexOf(item);
        this.locationContacts.splice(index, 1);
        if (!this.locationContacts.length > 0) {
          this.showApplicationContacts = true;
          this.showLocationContacts = false;
        }
      }
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    processPortChange() {
      if (this.provisionTemplate != null) {
        this.provisionTemplate.tpIndex = this.changedPort;
        let ponId = this.provisionTemplate.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
        this.changedPort = null;
        this.provisionWarningModal = false;
        this.approveApplication();
      }
    },
    
    

    async initialize() {
      await this.getApplication();
      this.fetchDocuments()
      this.getExistingServiceAccounts();
      this.fetchTickets();
      this.fetchApplicationComments();
      this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
    },
    async addApplicationComment(comment) {
      comment = comment.replace(/<div>/g, "");
      comment = comment.replace("</div>", "");
      comment = comment.replace(/<br>/g, "");
      Api()
        .post("/applicationComment", {
          isInternal: false,
          applicationId: parseInt(this.$route.params.applicationId),
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          this.notifyIsp();
          this.notifyFno();
          this.comment = "";
          this.fetchApplicationComments();
        });
    },
    fetchApplicationComments() {
      this.commentArray = [];

      Api()
        .get("/applicationComment/customer/byApplication/" + this.$route.params.applicationId)
        .then(async (response) => {
          this.commentArray = response.data.map((x) =>
                        ({
                            organisation: x.organisation,
                            commentedById: x.commentedById,
                            commentedByName: x.commentedBy.name,
                            commentedBySurname: x.commentedBy.surname,
                            comment: x.comment,
                            type: x.type,
                            createdAt: x.createdAt,
                            isInternal: x.isInternal,
                            id: x.id,
                            commentLogType: true,
                        })
                    )
                    this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        });
    },
    fetchDocuments() {
            Api()
                .get("/upload/byApplication/isp/" + this.applicationInfo.id)
                .then((res) => {
                    this.documents = res.data;
                });
        },
    checkDatatillIntegration() {
      Api()
        .get("/integrations/byName/Datatill")
        .then((response) => {
          if (response.data) {
            this.datatillIntegration = true;
            this.fetchDatatillCustomer();
          }
          console.log(response.data);
        });
    },
    fetchDatatillCustomer() {
      this.datatillContactType = "Primary";
      this.datatillContactTypeList = [];
      if (this.applicationInfo.primaryContactEmailAddress) {
        this.datatillContactTypeList.push("Primary");
      }
      if (this.applicationInfo.secondaryContactEmailAddress) {
        this.datatillContactTypeList.push("Secondary");
      }
      if (this.applicationInfo.billingContactEmailAddress) {
        this.datatillContactTypeList.push("Billing");
      }
      Api()
        .post("/datatill/customerList", {
          organisationId: this.$store.state.currentOrg.org.id,
          primaryContactEmail: this.applicationInfo.primaryContactEmailAddress,
          secondaryContactEmail: this.applicationInfo.secondaryContactEmailAddress,
          billingContactEmail: this.applicationInfo.billingContactEmailAddress,
          // contactEmail: 'cornelis.vanrensburg@gmail.com'
        })
        .then((response) => {
          this.allCustomers = response.data.allCustomers;
          this.foundExisting = [];
          if (response.data.primaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Primary",
              customerId: response.data.primaryCustomerId,
              fullName:
                this.applicationInfo.primaryContactTitle +
                " " +
                this.applicationInfo.primaryContactFirstname +
                " " +
                this.applicationInfo.primaryContactLastname,
              email: this.applicationInfo.primaryContactEmailAddress,
              mobile: this.applicationInfo.primaryContactMobileNumber,
              idNumber: this.applicationInfo.primaryContactIdNumber,
            });
            // this.applicationInfo.datatillCustomerId = response.data.customerId
            this.existingDatatillCustomer = true;
          }
          if (response.data.secondaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Secondary",
              customerId: response.data.secondaryCustomerId,
              fullName:
                this.applicationInfo.secondaryContactTitle +
                " " +
                this.applicationInfo.secondaryContactFirstname +
                " " +
                this.applicationInfo.secondaryContactLastname,
              email: this.applicationInfo.secondaryContactEmailAddress,
              mobile: this.applicationInfo.secondaryContactMobileNumber,
              idNumber: this.applicationInfo.secondaryContactIdNumber,
            });
            this.existingDatatillCustomer = true;
          }
          if (response.data.billingCustomerId !== null) {
            this.foundExisting.push({
              type: "Billing",
              customerId: response.data.billingCustomerId,
              fullName:
                this.applicationInfo.billingContactTitle +
                " " +
                this.applicationInfo.billingContactFirstname +
                " " +
                this.applicationInfo.billingContactLastname,
              email: this.applicationInfo.billingContactEmailAddress,
              mobile: this.applicationInfo.billingContactMobileNumber,
              idNumber: this.applicationInfo.billingContactIdNumber,
            });
            this.existingDatatillCustomer = true;
          }
          console.log(response.data);
        });
    },
    fetchDeviceBridges(id) {
      Api()
        .get("/deviceBridge/" + id)
        .then((response) => {
          this.deviceBridges = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    async routeToTicketSummary(id) {
      // if(customerOrganisationId===this.$store.state.currentOrg.org.id){
      this.$router.push({ path: "/ispTicketSummary/" + id });
      // let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
      //   return el.url === '/ispTicketSummary/:ticketId'})
      // await this.$store.dispatch('setCurrentRoute', route[0])
      // this.$router.push({ path: "/ispTicketSummary/" + id });
      // }else{
      //   confirm("You do not have permission to view these ticket details. Please contact your Organisation Administrator for further assistance.")
      // }
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },
    async fetchTickets() {
      await Api()
        .get("/allTickets/byApplication/customer/" + this.$route.params.applicationId)
        .then((response) => {
          this.tickets = response.data;
          let temp = response.data;
          this.ticketCarousalArray = temp.slice(0, 2);
        });
    },
    async getAvailableTemplates(deviceMakeId) {
      Api()
        .get(
          "/customer/organisationBridgeTemplate/byCustomerDeviceMake/" +
            deviceMakeId +
            "/" +
            this.applicationInfo.supplierOrganisationId
        )
        .then((response) => {
          this.bridgeTemplates = response.data;
        });
    },
    provisionAccount() {
      if (
        this.provisionTemplate != null &&
        this.deviceBridges.length > 0 &&
        this.deviceBridges.map((x) => x.tpIndex).includes(parseInt(this.provisionTemplate.tpIndex))
      ) {
        return false;
      } else {
        //  this.createServiceAccount()
        return true;
      }
    },
   
    viewTicket(item) {
      this.ticketItem = item;
      if (this.ticketItem.dueTime === null) {
        this.dateTimeSelect = false;
      } else {
        this.dateTimeSelect = true;
      }
      if (this.ticketItem.id) {
        this.fetchTicketComments(this.ticketItem.id);
      }
      this.fetchTicketAssignments(this.ticketItem.id);
      this.ticketItem.ticketCategoryId = this.ticketItem.ticketCategoryItem.ticketCategoryId;
      this.viewTicketModal = true;
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    createLocationContacts(contactId, contactTypeId) {
      Api().post("/locationContact", {
        contactId: contactId,
        locationId: this.applicationInfo.locationId,
        contactTypeId: contactTypeId,
        isActive: true,
        isDeleted: false,
      });
    },
    async approveApplication() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.provisionAccount()) {
          if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
            let customerOrganisationId = this.applicationInfo.packagesIsp.customerOrganisationId;
            let vlans = this.allVlans.filter(function(el) {
              return el.customerOrganisationId === customerOrganisationId && el.isPrimaryVlan;
            });
            if (vlans.length == 0) {
              confirm(
                this.applicationInfo.packagesIsp.customerOrganisation.name +
                  " does not have a primary vlan assigned. Please create/assign a primary vlan for this ISP before continuing."
              );
            } else {
              confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
            }
          } else {
            confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
          }
        } else {
          this.provisionWarningModal = true;
        }
      }
    },
    async approveApplicationProcess() {
      if (this.applicationInfo.primaryContactId) {
        await this.createLocationContacts(this.applicationInfo.primaryContactId, 2);
      }
      if (this.applicationInfo.secondaryContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.secondaryContactId, 5);
      }
      if (this.applicationInfo.billingContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.billingContactId, 8);
      }
      if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
        // let customerOrganisationId = this.applicationInfo.packagesIsp
        //   .customerOrganisationId;
        // let vlans = await this.allVlans.filter(function(el) {
        //   return (
        //     el.customerOrganisationId === customerOrganisationId &&
        //     el.isPrimaryVlan
        //   );
        // });
        // if (vlans.length > 0) {
        await this.createServiceAccount();
        // } else {
        //   confirm(
        //     this.applicationInfo.packagesIsp.customerOrganisation.name +
        //       " does not have a primary vlan assigned. Please create/assign a primary vlan for this ISP before continuing."
        //   );
        // }
      }
      Api()
        .put("/applications/" + this.$route.params.applicationId, {
          isApproved: true,
          approvedById: this.$store.state.user.id,
          isResolved: true,
          resolvedById: this.$store.state.user.id,
          resolvedDate: new Date(),
        })
        .then((this.applicationInfo.isApproved = true), (this.applicationInfo.isResolved = true));
    },
    rejectApplication() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to reject this application?") &&
          Api()
            .put("/customer/applications/" + this.$route.params.applicationId, {
              ispVerified: true,
              ispAccepted: false,
              ispVerifiedById: this.$store.state.user.id,
              ispVerifiedDate: new Date(),
              deniedReason: this.deniedReason
              //   resolvedDate: new Date(),
              //   isResolved: true
            })
            .then((response) => {
              this.notifyFno();
              (this.applicationInfo.ispVerified = true),
                (this.applicationInfo.ispAccepted = false),
                (this.applicationInfo.ispVerifiedDate = new Date()),
                (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
                (this.applicationInfo.ispVerifiedBy = this.$store.state.user),
                (this.deniedReasonModal = false);
            });
      }
    },
    getLinkedContacts() {
      Api()
        .get("/contacts/linked", {
          params: {
            idNumber: this.applicationInfo.primaryContactIdNumber,
            emailAddress: this.applicationInfo.primaryContactEmailAddress,
            mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          },
        })
        .then((response) => {
          this.linkedPrimaryContacts = response.data;
        });
      if (this.applicationInfo.secondaryContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedSecondaryContacts = response.data;
          });
      }
      if (this.applicationInfo.billingContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.billingContactIdNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedBillingContacts = response.data;
          });
      }
    },
    async getExistingServiceAccounts() {
      this.existingServiceAccounts = [];
      await Api()
        .get("/customer/serviceAccounts/active/byLocation/" + this.applicationInfo.locationId)
        .then((response) => {
          this.existingServiceAccounts = response.data;
          if (!this.existingServiceAccounts.length > 0) {
            this.applicationInfo.isPackageVerified = true;
          }
        });
    },
    async getApplication() {
      await Api()
        .get("/customer/applications/" + this.$route.params.applicationId)
        .then((response) => {
          this.applicationInfo = response.data;
          this.locationContacts = [];
          if (this.applicationInfo.location && typeof this.applicationInfo.location.devices !== "undefined") {
            for (let i = 0; i < this.applicationInfo.location.devices.length; i++) {
              if (
                this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "GPON ONU" &&
                this.applicationInfo.location.devices[i].isActive
              ) {
                if (this.applicationInfo.location) {
                  this.device = this.applicationInfo.location.devices[i];
                  this.getAvailableTemplates(this.device.deviceMakeModel.deviceMakeId);
                }
              }
            }
          }
         
          if (
            this.applicationInfo.location &&
            typeof this.applicationInfo.location.locationContacts !== "undefined" &&
            this.applicationInfo.location.locationContacts.length > 0
          ) {
            for (let y = 0; y < this.applicationInfo.location.locationContacts.length; y++) {
              if (
                this.applicationInfo.location.locationContacts[y].isActive &&
                !this.applicationInfo.location.locationContacts[y].isDeleted
              ) {
                this.locationContacts.push(this.applicationInfo.location.locationContacts[y]);
              }
            }
          }

          this.getLinkedContacts();
          if (!this.applicationInfo.hasTvOverFibre && this.applicationInfo.packagesIspId === null) {
            (this.applicationInfo.isInstallVerified = true), (this.applicationInfo.isDeviceVerified = true);
          }
        });
    },
    onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0]);
        },
        async createFile(file) {
            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                this.file.base64 = file;
                console.log(this.file)
                this.uploadDocument(this.file)
            }

            this.dragging = false;
        },
        uploadDocument(file) {
            this.file = {
                applicationId: this.applicationInfo.id,
                customerOrganisationId: this.applicationInfo.organisationId,
                name: file.name,
                base64: file.base64,
                type: file.type,
                isActive: true,
                isDeleted: false,
            }
            Api()
                .post('/upload', this.file).then(async response => {
                    this.file.id = response.data.id
                    this.file.createdAt = response.data.createdAt
                    this.documents.push(this.file)

                    // this.documents = await this.fetchTicketDocuments(this.$route.params.ticketId)
                })
        },
        removeFile() {
            this.file = '';
        },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    notifyFno() {
      Api().post("/notifications/application/notifyFno", {
        applicationId: this.$route.params.applicationId,
        organisationId: this.applicationInfo.supplierOrganisationId,
      });
    },
    notifyIsp() {
      Api().post("/notifications/application/notifyIsp", {
        applicationId: this.$route.params.applicationId,
        customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
      });
    },
  },
};
</script>

<style>
.greenBorder {
  background-color: #e6e6e6;
  border: 1px solid #99cc33;
  text-align: center;
}
.v-stepper__header {
  box-shadow: none;
}

.dropZone {
    width: 180px;
    height: 90%;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone:hover {
    border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.removeFile {
    width: 200px;
}
</style>
